// extracted by mini-css-extract-plugin
export default {"notification":"PopupNotification_notification__6kIu7","moveTop":"PopupNotification_moveTop__xraKL"};